import { Box, Flex, HStack, Link, List, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import { CloseIcon } from '../../assets/icons/CloseIcon';
import { FolderIcon } from '../../assets/icons/FolderIcon';
import { HomeIcon } from '../../assets/icons/HomeIcon';
import { LogoutIcon } from '../../assets/icons/LogoutIcon';
import { useAuthContext } from '../../contexts/AuthContext';
import { randomComponentId } from '../../utils/components/randomComponentId';

export const AdviceSideBar = () => {
  const location = useLocation();

  const { logout } = useAuthContext();

  const links = [
    {
      name: 'Início',
      icon: <HomeIcon fontSize="1.6rem" />,
      url: '/assessoria'
    },
    {
      name: 'Plataforma de Negócios',
      icon: <FolderIcon fontSize="1.6rem" />,
      url: '/corretor'
    }
  ];

  return (
    <List spacing="2rem" w="100%" fontSize="14px">
      {links.map((link) => (
        <HStack key={randomComponentId()} justify="space-between">
          <Link
            href={link.url}
            _hover={{ opacity: 0.7 }}
            color={location.pathname === link.url ? '#146CFA' : '#001E64'}
          >
            <Flex display="flex" gap="1rem" justify="center" align="center">
              {link.icon}
              <Text
                fontWeight={location.pathname === link.url ? 'bold' : 'normal'}
              >
                {link.name}
              </Text>
            </Flex>
          </Link>

          <Box
            w="5px"
            h="3rem"
            bg={location.pathname === link.url ? '#146CFA' : 'transparent'}
            border={
              location.pathname === link.url ? '2px solid #146CFA' : 'none'
            }
            borderLeftRadius="1rem"
          />
        </HStack>
      ))}
      <HStack key={randomComponentId()} justify="space-between">
        <Link
          href={process.env.REACT_APP_PORTAL_URL}
          _hover={{ opacity: 0.7 }}
          onClick={logout}
        >
          <Flex display="flex" gap="1rem" justify="center" align="center">
            <LogoutIcon fontSize="1.6rem" />
            <Text>Sair</Text>
          </Flex>
        </Link>
      </HStack>
    </List>
  );
};
